import React, { type FC } from "react";
import "./NotFound.scss";
import { Svg } from "@shared/ui/svg";

const NotFound: FC = () => {
    return (
        <div className="not-found">
            <Svg className="svg_icon" src="/images/common/404.svg" alt="" />
            <div className="comment">Страница не найдена</div>
        </div>
    );
};

export default NotFound;
